import { render, staticRenderFns } from "./OneTimePayrollContribution.vue?vue&type=template&id=d1837550"
import script from "./OneTimePayrollContribution.vue?vue&type=script&lang=ts"
export * from "./OneTimePayrollContribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports